import StandardSwitch from 'components/standard/StandardSwitch'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSettings } from 'redux/actions/settingsActions'
import { setShowEthInCurrency } from 'redux/actions/settingsActions'

export default function ShowEthOrCurrency() {
    const settings = useSelector((state) => state.settings)
    const { currency, showEthInCurrency } = settings
    const [showCurrency, setShowCurrency] = useState(showEthInCurrency)
    const dispatch = useDispatch()
    console.log(`showCurrency ${showCurrency}`)
    return (
        <p>
            {`${showEthInCurrency ? currency : 'ETH \u{039E}'}`}
            <StandardSwitch
                isChecked={showEthInCurrency}
                onChange={() => {
                    setShowCurrency(!showCurrency)
                    const newSettings={...settings,showEthInCurrency:!showEthInCurrency}
                    dispatch(setSettings(newSettings))
                }}
            />
        </p>
    )
}